import React, { Component } from 'react';
import { Alert } from 'antd';
import { CREDENTIALS_STATUS } from 'app/constants';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import translate from 'app/translations';
import AgentProfilePropType from '../AgentProfilePropType';

import './Credentials.scss';

export default class CredentialStatus extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    const {
      credentialProgress,
    } = this.props.agentProfile;

    const {
      hasLicense,
      hasW9,
    } = credentialProgress.section;
    return (
      <div id="credentialStatus" className="credential-status m-b-16">
        {credentialProgress.credentialsStatus === CREDENTIALS_STATUS.INFO && (
          <Alert
            message={this.t('Credentials.credentialStatus.heading')}
            description={(
              <ul>
                {!hasLicense && (
                  <li>
                    {this.t('Credentials.credentialStatus.stepsOutstanding.hasLicense')}
                  </li>
                )}

                {!hasW9 && (
                  <li>
                    {this.t('Credentials.credentialStatus.stepsOutstanding.hasW9')}
                  </li>
                )}
              </ul>
            )}
            type="error"
            showIcon
          />
        )}
      </div>
    );
  }
}

CredentialStatus.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
};
